<template>
<div class="p-4 text-center text-white">

  <div class="font-valorant my-8">
    <h1 class=" text-3xl ">PurchAse Accounts</h1>
    <h4 class="">click on A Listing for More info</h4>
    <p class="text-sm font-sans">Make sure you have set your Litecoin Payment address in your <router-link to="/myaccount" class="underline">account settings</router-link> before making an order!</p>
  </div>

<table class="table-auto text-center text-white m-auto out w-full text-sm lg:w-5/6 md:text-md">
  <thead>
    <tr>

      <th class=" py-2">
       
        <p> <i class="fa fa-user" aria-hidden="true"></i> Seller</p>
        </th>

      <th class="py-2">
       
        <p> <i class="fa fa-globe" aria-hidden="true"></i> Region</p>
        </th>

      <th class=" py-2">
       
        <p> <i class="fa fa-address-card" aria-hidden="true"></i> Display Name</p>
        </th>
      <th style="max-width: 120px" class=" py-2">
       <i class="fa fa-level-up" aria-hidden="true"></i>

        Rank
        </th>
      <th style="max-width: 120px" class=" py-2">
       <i class="fa fa-microchip" aria-hidden="true"></i>

        CPU
        </th>
      <th style="max-width: 120px" class=" py-2">
       <i class="fa fa-cogs" aria-hidden="true"></i>

        GPU
        </th>                  
      <th class=" py-2"><i class="fa fa-usd" aria-hidden="true"></i>
      Price
      </th>
      <th class=" py-2"><i class="fa fa-clock-o" aria-hidden="true"></i>
      Date
      </th>      
    </tr>
  </thead>
  <tbody>
    <tr @click="goToListing(listing)" v-bind:key="listing.dateAdded.toString()" :class="(index % 2 ? 'bg-gray-900 hover:bg-gray-700' : 'bg-gray-800 hover:bg-gray-700')" v-for="(listing, index) in listings">



      <td class="border py-2 overflow-scroll">
        <p class="text-sm md:text-md">{{listing.seller}}</p>
        </td>  

      <td class="border py-2 overflow-scroll">
        <p class="text-sm md:text-md">{{listing.region}}</p>
        </td>      
      <td class="border py-2 overflow-scroll">
        <p class="text-sm md:text-md">{{listing.displayName}}</p>
        </td>
      <td class="border py-2">
        
        <img style="max-width: 25px" class="m-auto" :src="getRankImage(listing)" alt="">
        <p class="text-sm md:text-md">{{listing.rank}}</p>

      </td>

      <td class="border py-2 overflow-scroll">
        <p class="text-sm md:text-md">{{listing.cpu}}</p>
        </td>
      <td class="border py-2 overflow-scroll">
        <p class="text-sm md:text-md">{{listing.gpu}}</p>
        </td>
      <td class="border py-2">{{listing.price}} USD</td>
      <td class="border py-2">{{moment(listing.dateAdded).fromNow()}}</td>

    </tr>  
  </tbody>
</table>

</div>
</template>

<script>
import moment from 'moment'

import firebase from 'firebase/app'
import db from '@/db'

export default {
  name: 'BuyAccounts',
  data() {
    return {
      moment: '',
      listings: [],

      rankIcons: {
        gold: require('@/assets/ranks/gold.png'),
        immortal: require('@/assets/ranks/immortal.png'),  
        plat: require('@/assets/ranks/plat.png'), 
        diamond: require('@/assets/ranks/diamond.png'),
        radiant:  require('@/assets/ranks/radiant.png'),
        silver:  require('@/assets/ranks/silver.png'),
        bronze:  require('@/assets/ranks/bronze.png'), 
        iron:  require('@/assets/ranks/iron.png'),  		  
      }

    }
  },
 async beforeMount(){
   this.moment = moment

        const snapshot = await db.collection('Listings').get()
        this.listings = snapshot.docs.map(doc => {
          const eventData = doc.data()
          eventData.id = doc.id

          return eventData
        });

        //console.log(this.listings)

        
 },
 methods: {
   goToListing(listing) {
     this.$router.push('/listing/'+listing.id);
   },

    getRankImage(listing) {
        

        if (listing.rank == 'RADIANT') {
            return this.rankIcons.radiant
        } else if (listing.rank.includes('Immortal')) {
            return this.rankIcons.immortal
        } else if (listing.rank.includes('Diamond')) {
            return this.rankIcons.diamond
        } else if (listing.rank.includes('Plat')) {
            return this.rankIcons.plat
        } else if (listing.rank.includes('Gold')) {
            return this.rankIcons.gold
        } else if (listing.rank.includes('Silver')) {
            return this.rankIcons.silver
        } else if (listing.rank.includes('Bronze')) {
            return this.rankIcons.bronze
        } else if (listing.rank.includes('Iron')) {
            return this.rankIcons.iron
        }
        

    }

 }    

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->




// WEBPACK FOOTER //
// src/components/BuyAccounts.vue